import { render } from "./CouponCard.vue?vue&type=template&id=3856c6b6&scoped=true&ts=true"
import script from "./CouponCard.vue?vue&type=script&lang=ts"
export * from "./CouponCard.vue?vue&type=script&lang=ts"

import "./CouponCard.vue?vue&type=style&index=0&id=3856c6b6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3856c6b6"]])

export default __exports__